import { useEffect, useState } from "react";

export default function useGithubContributors(owner, repo) {
  const [contributors, setContributors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!owner || !repo) return;
    let cancelled = false;

    async function fetchContributors() {
      try {
        setLoading(true);
        const response = await fetch(`https://api.github.com/repos/${owner}/${repo}/contributors?per_page=5`);
        if (!response.ok) { if (!cancelled) setContributors([]); return; }
        const data = await response.json();
        if (!cancelled) setContributors(Array.isArray(data) ? data : []);
      } catch {
        if (!cancelled) setContributors([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchContributors();
    return () => { cancelled = true; };
  }, [owner, repo]);

  return { contributors, loading };
}